import React from "react";
import { MLabel, MRadioButton, ValidatedForm } from "components/forms";
import { IstanzaRiconoscimento } from "./IstanzaRiconoscimento";
import { Ricorso } from "./Ricorso";

export class RiconoscimentoEstero extends ValidatedForm {
  emptyFields = {
    riconoscimento: "",
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    validationError: "",
    defaultPayload: "",
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
    _subformRef: React.createRef(),
  };

  componentDidMount() {
    this.initializeFromPayload();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultPayload !== this.props.defaultPayload) {
      this.initializeFromPayload();
    }
  }

  initializeFromPayload = () => {
    const payload = this.props.defaultPayload;

    if (this.state.riconoscimento !== "") {
      return;
    }

    this.setState((prevState) => {
      let defaultPayload = null;
      let defaultOption = "";

      if (payload.riconoscimento && payload.riconoscimento.length > 0) {
        defaultOption = "Riconoscimento";
        defaultPayload = payload.riconoscimento[0];
      } else if (payload.ricorso && payload.ricorso.length > 0) {
        defaultOption = "Ricorso";
        defaultPayload = payload.ricorso[0];
      }

      return {
        riconoscimento: defaultOption,
        defaultPayload,
        defaultValues: {
          ...prevState.defaultValues,
          riconoscimento: defaultOption,
        },
      };
    });
  };

  onSubmit = () => {
    let validationError = "";
    let isValid = true;
    const { riconoscimento, _subformRef } = this.state;

    if (!riconoscimento) {
      validationError = "Selezionare una delle due opzioni";
      isValid = false;
    }

    if (_subformRef.current) {
      const isSubformValid = _subformRef.current.onSubmit();
      if (!isSubformValid) {
        isValid = false;
      }
    }

    this.setState({ validationError: validationError });
    return isValid;
  };

  onChangeOption = (_, value) => {
    this.setState({
      riconoscimento: value,
      defaultPayload: null,
      validationError: "",
    });
  };

  getPayload = () => {
    const { riconoscimento, _subformRef } = this.state;
    let payload = {};

    if (_subformRef.current) {
      const subformPayload = _subformRef.current.getPayload();
      payload = { ...subformPayload };
    }

    payload.qualificationCode = "title15";

    if (riconoscimento === "Riconoscimento") {
      payload.qualificationType = "Riconoscimento";
      payload.template = "Title15_Riconoscimento";
    } else if (riconoscimento === "Ricorso") {
      payload.qualificationType = "Ricorso";
      payload.template = "Title15_Ricorso";
    }

    return payload;
  };

  //--- ---

  render() {
    const { riconoscimento, defaultPayload, validationError, _subformRef } = this.state;

    return (
      <>
        <div className="user mt-3">
          <MLabel
            infoText="Indicare gli estremi della domanda di riconoscimento del titolo estero e/o del contenzioso giurisdizionale pendente"
            className="col-md-12"
          />

          <MRadioButton
            id="riconoscimento"
            name="riconoscimento"
            payload={{
              options: [
                {
                  value: "Riconoscimento",
                  label:
                    "Istanza di riconoscimento per la quale, alla data del 24 aprile 2025, siano decorsi i termini di conclusione del relativo procedimento.",
                },
                {
                  value: "Ricorso",
                  label: "Contenzioso giurisdizionale per mancata adozione, da parte dell'amministrazione, di un provvedimento espresso.",
                },
              ],
            }}
            value={riconoscimento}
            onChange={this.onChangeOption}
            className="col-md-12"
          />

          <div className="mt-4">
            {riconoscimento === "Riconoscimento" && (
              <div className="p-4 border border-secondary rounded-lg">
                <IstanzaRiconoscimento ref={_subformRef} enrollmentId={this.props.enrollmentId} defaultPayload={defaultPayload} />
              </div>
            )}

            {riconoscimento === "Ricorso" && (
              <div className="p-4 border border-secondary rounded-lg">
                <Ricorso ref={_subformRef} enrollmentId={this.props.enrollmentId} defaultPayload={defaultPayload} />{" "}
              </div>
            )}
          </div>

          {validationError && <div className="text-danger">{validationError}</div>}
        </div>
      </>
    );
  }
}
